export default "/_next/static/chunks/fonts/Channel4Chadwick-Regular-33f0d3f5c9bd9a6def466c7f3d8aea37.woff2";